import { sponsorAxiosInstance } from './base-service';

export const GetOktUserToken = async (isAthlete = false) => {
  const path = isAthlete ? 'benefit/athlete_auth_login/v1' : 'v1/sponsor/login/Okta';
  const res = await sponsorAxiosInstance.get(path, {});
  return res;
};
